import { formatDate } from "../dateTime";

/** Example: 12 September 2023 */
export const dateToFullDateWithLongMonth = (isoDate: string) => formatDate(isoDate, "d MMMM yyyy")

/** Example: 4 Aug */
export const dateToDayAndShortMonth = (isoDate: string) => formatDate(isoDate, "d MMM");

/** Example: 12/08/1996 */
export const dateToBritishDate = (isoDate: string) => formatDate(isoDate, "dd/MM/yyyy");

/** Example: 12/08/1996 */
export const dateToEnglishDate = dateToBritishDate;

/** Example: 12/08/1996 13:02 */
export const dateToEnglishDateWith24HrTime = (isoDate: string) => formatDate(isoDate, "dd/MM/yyyy HH:mm")